export default {
  namespaced: true,
  camera_proxy: {
    title: "camera proxy | cameras proxy",
    id: "camera proxy id",
    rtsp_available: "Activar transmisión RTSP",
    last_connection: "última conexión",
    assigned: "asignado",
    rec_mode: "modo de grabación",
    rec_hours: "días de grabación",
    days: "Días",
    limit: {
      "7_days": "7 días",
      "3_days": "3 días",
      "14_days": "14 días",
      "30_days": "30 días",
      "60_days": "60 días",
      "90_days": "90 días",
      "180_days": "180 días",
      "1_year": "1 año",
      "2_years": "2 años",
      custom: "Personalizado",
    },
    recording_enable: "habilitar grabación",
    on_demand: "habilitar video bajo demanda",
    vbr_quality: "Calidad VBR",
    frame_rate: "Tasa de fotogramas",
    resolution: "Resolución",
    store:{
      space_200_gb: "200 GB",
      space_500_gb: "500 GB",
      space_1_tb: "1 TB",
    },
    profile: "perfil",
    encoding: "codificación",
    resolution: "resolución",
    frame_rate: "velocidad de cuadros",
    bitrate: "tasa de bits",
    vbr: "vbr",
    quality: "calidad",
    gov: "gov",
    send_to_seproban: "Enviar a seproban"
  },
};
